module.exports = __webpack_public_path__ + "static/media/no-organizations-connected.0897f886.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/no-organizations-connected.png
// module id = 1374
// module chunks = 3